
define('template!adminNotificationPreferenceView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="notification-preferences-container">\n    <h2>' +
((__t = ( _.i18n('notification.preferences.title', 'Notification Preferences') )) == null ? '' : __t) +
'</h2>\n\n    <form id="notification-preferences-form">\n        <div class="form-group main-toggle">\n            <label class="checkbox-label">\n                <input type="checkbox" id="enable-notifications" />\n                <strong>' +
((__t = ( _.i18n('notification.preferences.overall.title', 'Enable Notification System') )) == null ? '' : __t) +
'</strong>\n            </label>\n            <p class="help-text">' +
((__t = ( _.i18n('notification.preferences.overall.desc', 'Toggle this to enable or disable the entire notification system') )) == null ? '' : __t) +
'</p>\n        </div>\n\n        <hr />\n\n        <div class="notification-types-section">\n            <h3>' +
((__t = ( _.i18n('notification.preferences.per.type.title', 'Individual Notification Types') )) == null ? '' : __t) +
'</h3>\n            <p class="help-text">' +
((__t = ( _.i18n('notification.preferences.per.type.desc', 'Configure which types of notifications you want to receive (when the system is enabled)') )) == null ? '' : __t) +
'</p>\n\n            <div class="notification-grid">\n                ';
 _.each(notificationTypes, function(isMuted, notificationType) { ;
__p += '\n                <div class="form-group notification-item">\n                    <label class="checkbox-label">\n                        <input\n                                type="checkbox"\n                                id="notification-' +
((__t = ( notificationType )) == null ? '' : __t) +
'"\n                                class="notification-checkbox"\n                                data-notification-type="' +
((__t = ( notificationType )) == null ? '' : __t) +
'"\n                        ' +
((__t = ( !isMuted ? 'checked' : '' )) == null ? '' : __t) +
'\n                        />\n                        ' +
((__t = ( formatNotificationLabel(notificationType) )) == null ? '' : __t) +
'\n                    </label>\n                </div>\n                ';
 }); ;
__p += '\n            </div>\n        </div>\n\n        <div class="form-actions">\n            <button type="button" id="save-preferences" class="btn btn-primary">\n                ' +
((__t = ( _.i18n('common.save', 'Save') )) == null ? '' : __t) +
'\n            </button>\n        </div>\n    </form>\n</div>';

}
return __p
};});

